export const readQueryParameters = (): Record<string, string> => {
  const params = new URLSearchParams(window.location.search.slice(1));
  const res: Record<string, string> = {};
  // eslint-disable-next-line no-restricted-syntax
  for (const [key, value] of params) {
    res[key] = value;
  }
  return res;
};
